import { Grid, Skeleton } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { useApiQuery } from "../../../../../../../core/api/useApiQuery"
import { RefetchIntervals } from "../../../../../../../core/api/refetchIntervals"
import { OrderType } from "../../../../../../payments/orderTypes"
import { fetchUserPos, FetchUserPosResponse, UserWeekMenu } from "../../../weekMenuApi"
import { PurchaseOrder } from "../../../weekMenuTypes"
import { DatePeriod } from "../../../../../../../shared/components/filters/selectDatePeriodFilter/SelectDatePeriodFilter"

import { TakeawayPanel } from "./TakeawayPanel"

const useStyles = makeStyles()(() => ({
    column: {
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
    },
    skeletonCard: {
        height: "20rem",
        borderRadius: "1rem",
    },
}))

const selectTakeaways = (data: FetchUserPosResponse): PurchaseOrder[] =>
    (data.orders ?? []).filter((order) => order.orderType === OrderType.TAKE_AWAY)

type UserTakeawayProps = Readonly<{
    period: DatePeriod
}>

export function UserTakeaway({ period }: UserTakeawayProps) {
    const { classes } = useStyles()

    const { data: takeaways, isLoading } = useApiQuery(fetchUserPos, {
        queryName: UserWeekMenu.USER_POS_PURCHASES,
        dependencies: {
            period,
            orderType: OrderType.TAKE_AWAY,
        },
        select: selectTakeaways,
        refetchInterval: RefetchIntervals.short,
    })

    if (isLoading) {
        return (
            <Grid item xs={12} className={classes.column}>
                <Skeleton variant="rectangular" className={classes.skeletonCard} />
            </Grid>
        )
    }

    return (
        <Grid item xs={12} className={classes.column}>
            <TakeawayPanel takeaways={takeaways ?? []} period={period} />
        </Grid>
    )
}
